(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[883],{

/***/ "2cCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Transport", function() { return Transport; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Transport = function Transport(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M26.89 11.97a1.73 1.73 0 0 0-1.2-1.03l-3.37-.88a5.9 5.9 0 0 0-2.64-.05l-3.06.61-3.08-3.41a2.44 2.44 0 0 0-2.22-.78l-1.39.22c-.37.06-.68.3-.84.63-.16.33-.14.73.05 1.06l2 3.4-3.34.67-1.37-1.1a2.02 2.02 0 0 0-1.7-.39l-.68.16c-.42.1-.77.4-.94.8-.17.4-.14.85.09 1.22l1.5 2.49A5.26 5.26 0 0 0 10.23 18l1.57-.32-.92 4.23a1.38 1.38 0 0 0 1.36 1.68h.1l1.48-.1h.11a2.87 2.87 0 0 0 2.23-2.05l1.4-4.93 7.07-1.44c.9-.18 1.67-.74 2.13-1.53.28-.48.32-1.05.1-1.57h.03ZM11.52 8.42l.13-.02c.15-.02.3.03.41.14l2.3 2.54-1.14.23-1.7-2.9Zm2.74 12.48a.85.85 0 0 1-.63.6l-.6.04 1.12-5.23 1.5-.3-1.4 4.89h.01Zm9.99-7.78-6.38 1.3c-.05-.1-.1-.2-.19-.3a1.18 1.18 0 0 0-1.09-.34l-2.98.6c-.62.14-1.1.59-1.3 1.18l-2.47.5a3.24 3.24 0 0 1-3.42-1.5L5.6 13.2l1.21.98c.31.25.71.34 1.1.27l12.19-2.47a3.71 3.71 0 0 1 1.72.04l3.04.8c-.17.16-.38.27-.61.32v-.02Z"
  }));
};

/***/ })

}]);